import { useQuery } from "@tanstack/react-query";
import { fetchContacts } from "@/api/contact/contact";
import { useAuth } from "@/providers/auth";

// TODO: Should have stale time of Infinity once the creation of a contact
// is being handled by mutation hook that refetchs the list after success
export const useContacts = ({ queryFn, queryKey, enabled, ...rest } = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  const isEnabled = !!id && enabled !== false;
  return useQuery({
    queryKey: ["contacts"],
    queryFn: () => fetchContacts(id),
    placeholderData: [],
    enabled: isEnabled,
    ...rest,
  });
};
